const SERVER_URL = process.env.REACT_APP_SERVER_URL || (process.env.NODE_ENV === 'production' ? '' : 'http://localhost:3001');

class DBService {
    async saveResume(email, resumeData) {
        try {
            const res = await fetch(`${SERVER_URL}/api/resumes`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email, resume: resumeData })
            });

            if (!res.ok) throw new Error('Failed to save resume');
            return await res.json();
        } catch (error) {
            console.error('[DBService] saveResume error:', error);
            throw error;
        }
    }

    async getSavedResumes(email) {
        try {
            const res = await fetch(`${SERVER_URL}/api/resumes/${encodeURIComponent(email)}`);
            if (!res.ok) throw new Error('Failed to fetch resumes');
            const resumes = await res.json();
            
            // Sort by most recently updated
            resumes.sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));
            return resumes;
        } catch (error) {
            console.error('[DBService] getSavedResumes error:', error);
            return [];
        }
    }
    
    async deleteResume(email, resumeId) {
        try {
            const res = await fetch(`${SERVER_URL}/api/resumes/${encodeURIComponent(email)}/${encodeURIComponent(resumeId)}`, {
                method: 'DELETE'
            });

            if (!res.ok) throw new Error('Failed to delete resume');
            return true;
        } catch (error) {
            console.error('[DBService] deleteResume error:', error);
            return false;
        }
    }
}

export const dbService = new DBService();
